<template>
  <div id="app1">
    <!-- 底部导航栏 -->
    <el-menu
      class="bottom-nav"
      mode="horizontal"
      :default-active="activeIndex"
      @select="handleSelect"
      :collapse="false"
      :background-color="'#fff'"
      :text-color="'#ccc'"
      :active-text-color="'black'" 
    >
       <!-- 动态渲染菜单项 -->
       <el-menu-item
       v-for="(item, index) in menuItems"
       :key="item.index"
       :index="item.index"
     >
       <img class="menu-icon" :src="item.icon" :alt="item.name" />
       <span>{{ item.name }}</span>
     </el-menu-item>
      <!-- <el-menu-item index="indexmainh5">
        <img class="menu-icon" src="@/assets/icon2-15.svg" alt="首页"  />
        <span>首页</span>
      </el-menu-item>
      <el-menu-item index="productrange">
        <img class="menu-icon" src="@/assets/icon2-16.svg" alt="产品系列" />
        <span>产品系列</span>
      </el-menu-item>
      <el-menu-item index="3">
        <img class="menu-icon" src="@/assets/icon2-17.svg" alt="用户服务" />
        <span>用户服务</span>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
 import axios from 'axios';
 import apiUrls from '@/http/http';
 import { Dialog, Toast } from "vant";
 import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      //activeIndex: '1', // 默认选中的菜单项
      activeIndex: '1', // 默认选中的菜单项
      menuItems: [
        {
          index: 'indexmainh5',
          icon: require('@/assets/icon2-15.svg'),
          name: '首页'
        },
        {
          index: 'productrange',
          icon: require('@/assets/icon2-16.svg'),
          name: '产品系列'
        },
        {
          index: 'userservices',
          icon: require('@/assets/icon2-17.svg'),
          name: '用户服务'
        }
      ]
    
    };
  },
  mounted() {
    /*
    * 查询加密底部菜单数据
    */
    this.produtbyke();
  },
  created() {
                this.isMobiles();
        },
  methods: {
    /**
     * convertMenuData
     * @description 将后端返回的菜单数据转换为前端需要的格式
     * @param {Array} backendData - 后端返回的菜单数据
     * @returns {Array} - 转换后的菜单数据
     */
    transformMenuData(backendData) {
    return backendData.map(item  => ({
      index: item.routekey, 
      name: item.name , 
      icon: `${apiUrls.devApi}${item.iconpath}`,  
    }));
  },
    async produtbyke(){
        try {
          const productName = this.$route.query.productsname;
                const requestBody = {
                  productsname: productName // Replace with the actual product number
                };

                const response = await axios.get(`${apiUrls.baseUrl}/website/api/geth5menuitems`, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                const result = await this.decryptAES(response.data.mixedData); 
                          if(result) {
                            //  console.log(result);
                             this.menuItems = this.transformMenuData(result);
                          }else{
                            this.$message.error('获取数据失败');
                          }

                
                } catch (error) {
                      console.error('Error:',  error);
                  }

                },

                /**
                 * 解密AES
                 */
   async decryptAES(mixedData) {
    try {
        // console.log("🔹 混淆数据:", mixedData);

        // 提取密钥和真实的加密数据
        const insertIndex = 10; // 后端在第 10 个字符后插入密钥
        const encryptedData = mixedData.substring(0, insertIndex) + mixedData.substring(insertIndex + 24); // 24 是 Base64 编码的 AES 密钥长度
        const keyBase64 = mixedData.substring(insertIndex, insertIndex + 24);

        // console.log("🔹 提取出的密钥 (Base64):", keyBase64);
        // console.log("🔹 真实加密数据:", encryptedData);

        // 解析 Base64
        const key = CryptoJS.enc.Base64.parse(keyBase64);
        const cipherText = CryptoJS.enc.Base64.parse(encryptedData);

        // AES-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: cipherText },
            key,
            { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        );

        if (!decrypted || decrypted.sigBytes <= 0) throw new Error("解密失败，可能密钥错误");

        // 转换为 UTF-8 字符串
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        // console.log("🔹 解密后的文本:", decryptedText);

        if (!decryptedText) throw new Error("解密失败，数据无效");

        // 用正则去掉前面的时间戳及冒号，例如 "1742969450878:" 部分
        const jsonPart = decryptedText.replace(/^\d+:/, "");
        // console.log("🔹 去除前缀后的 JSON 数据:", jsonPart);

       // 将 JSON 字符串转换为对象，并返回
       return JSON.parse(jsonPart);
    } catch (error) {
        console.error("❌ 解密失败:", error.message);
        return null;
    }
},

         /**
             * 判断手机或者电脑然后跳转相应的路由
             */
             isMobiles(){
                // 解释:
                    // 1. `/iPhone|iPad|iPod|Android/i` - 这是一个正则表达式，
                    //    它会匹配包含 "iPhone"、"iPad"、"iPod" 或 "Android" 字符串的内容。
                    //    - `|` 表示“或”运算符，匹配其中的任意一个关键字。
                    //    - `/i` 表示忽略大小写（即 "iphone"、"Iphone"、"IPHONE" 等都会匹配）。
                    // 2. `navigator.userAgent` - 这是浏览器的用户代理字符串，它包含了设备、操作系统、浏览器等信息。
                    //    例如，iPhone 的 `userAgent` 字符串可能包含 "iPhone" 字样。
                    // 3. `test(navigator.userAgent)` - 使用正则表达式 `test` 方法来检查 `navigator.userAgent` 字符串中
                    //    是否包含上述的任何一个关键字。如果匹配，返回 `true`；否则，返回 `false`。
                    // 4. `const isMobile` - 根据 `test` 方法的返回值将结果存储到 `isMobile` 变量中。
                    //    - 如果设备是手机或平板，`isMobile` 为 `true`。
                    //    - 如果设备是桌面设备（如 PC 或 Mac），`isMobile` 为 `false`。
                // 判断是否是手机
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    // console.log("++++++++++++++++++++++=======================")
                
                    //如果是手机
                        if(!isMobile){
                        // 判断当前路由是否已经是目标路由，如果是则不进行跳转
                        if (this.$route.name !== 'indexmain') {
                        this.$router.push({ name: 'indexmain' });
                        }
                    }
            }, 




    handleSelect(index) {
     
      this.$nextTick(() => {
        this.activeIndex = index;
        // console.log('选中的菜单项索引:', index);
        this.$router.push({ name: index }); // 使用命名路由
      });
    }
  }
};
</script>

<style scoped>
#app1 {
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
}

/* 底部导航栏样式 */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height:8vh;
  background-color: #fff;
  border-top: 0px solid white;
  z-index: 100;
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items:center
}
/* 去除下划线 */
.el-menu {
  border: none;  /* 禁用菜单边框 */
  border-bottom: none !important;
}
/* 去除下划线的关键部分 */
.el-menu-item.is-active {
  border-bottom: none !important; /* 去掉选中项的下划线 */
}
.el-menu-item.is-active .menu-icon{
 /* //变为黑色 */
  filter: brightness(0) saturate(100%) invert(22%) sepia(100%) saturate(100%) hue-rotate(123deg) brightness(104%) contrast(101%);

  
}
.el-menu--horizontal>.el-menu-item {
 height: 50px;;
}
.el-menu-item::after {
  content: none !important;/* 去除伪元素的下划线 */
 
}
.el-menu-item {
  display: flex;
  flex-direction: column; /* 使图标和文本垂直排列 */
  align-items: center;    /* 使图标和文本水平居中 */
   padding: 0 8vw;
}

.menu-icon {
  width: 8vw;  /* 设置图片的宽度 */
 color: #ccc;
  
}


.el-menu-item span {
margin:0;
padding:0;
line-height:3vh

}
</style>
